import WyattModal from "modal";
import { registerComponent } from "helpers";

const STORAGE_KEY = "market-suggestion-dismissed";
const CHECKED_KEY = "market-suggestion-checked";
const SUGGESTIONS_URL = "/browsing_context_suggestions.json";

/**
 * Modal that offers a one-click switch to the visitor's detected market when
 * it differs from the market they're browsing. Shown once per browser.
 */
export default class MarketSuggestion extends WyattModal {
  connectedCallback() {
    super.connectedCallback();
    this.maybeOpenSuggestion();
  }

  /**
   * Fetches the storefront browsing-context suggestion and opens the modal
   * when the detected country has a matching localization option.
   */
  async maybeOpenSuggestion() {
    try {
      if (
        localStorage.getItem(STORAGE_KEY) ||
        sessionStorage.getItem(CHECKED_KEY)
      ) {
        return;
      }
    } catch (error) {
      return;
    }

    try {
      const response = await fetch(SUGGESTIONS_URL);
      if (!response.ok) return;

      const data = await response.json();
      const detected = data?.detected_values?.country?.handle;

      if (!detected || detected === this.dataset.currentCountry) {
        this.markChecked();
        return;
      }

      const option = this.dialog.querySelector(
        `[data-suggestion-country="${CSS.escape(detected)}"]`,
      );

      if (!option) {
        // third-country visitor with no matching market
        this.markChecked();
        return;
      }

      option.hidden = false;
      this.open();

      // shown once per browser, however it gets closed
      try {
        localStorage.setItem(STORAGE_KEY, "1");
      } catch (error) {
        // private browsing; it may reappear next visit
      }
    } catch (error) {
      // browsing-context endpoint unavailable; fail silently
    }
  }

  /**
   * Per-session marker so matched visitors don't re-fetch on every page view.
   */
  markChecked() {
    try {
      sessionStorage.setItem(CHECKED_KEY, "1");
    } catch (error) {
      // private browsing; worst case we re-fetch next page view
    }
  }
}

registerComponent("market-suggestion", MarketSuggestion);
